/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import './InsuranceSubHeader.scss'
import parse from 'html-react-parser'
import { CommonUtils } from '../../../../utils/CommonUtils'
import { IInpatientTypeInsurance } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'

export interface IInsuranceSubHeaderProps {
	data: IInpatientTypeInsurance
}
export class InsuranceSubHeader extends React.Component<IInsuranceSubHeaderProps> {
	private readonly dateFormat = 'MM/DD/YYYY'

	getInsuranceDates(val: IInpatientTypeInsurance): string | undefined {
		return (
			val.effectiveDateRanges &&
			val.effectiveDateRanges.reduce(function(result, current, idx) {
				return idx === 0 ? CommonUtils.DateRange(current.item1, current.item2, true) : result + (Object.keys(current).length > 0 ? '<br />' : '') + CommonUtils.DateRange(current.item1, current.item2, true)
			}, '')
		)
	}

	render(): React.ReactNode {
		const insuranceSubHeaderModel = this.props.data
		if (insuranceSubHeaderModel && insuranceSubHeaderModel.definition && insuranceSubHeaderModel.definition.trim() !== '') {
			const dates = this.getInsuranceDates(insuranceSubHeaderModel)
			const showDates = typeof dates !== 'undefined' && dates !== null && dates.trim() !== '' && dates.toLowerCase() !== 'no date range'
			return (
				<tr className="sub-header topline">
					<td>Insurance Type:</td>
					<td colSpan={showDates ? 1 : 3}>{insuranceSubHeaderModel.definition}</td>
					{showDates && <td>Effective Date:</td>}
					{showDates && dates && <td>{parse(dates)}</td>}
				</tr>
			)
		}
		return null
	}
}
